export default __webpack_public_path__ + "static/media/eye.49cb4f41.svg";